import type { Contents } from '@/wabunka-src/common/features/Featured/models/featured/featured';

import type { MicroCMSImage } from 'microcms-js-sdk';

export type DestinationContent = Contents[number];

/**
 * MicroCMS destination content response structure
 * Endpoint: en-featured/{destination}
 */
export interface DestinationContentResponse {
  id: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  revisedAt: string;
  type: string[];
  titleEn: string;
  backgroundWideMedias: MicroCMSImage[];
  backgroundTallMedias: MicroCMSImage[];
  destinationTags: string[];
  summary: string;
  ogImage?: MicroCMSImage;
  contents: DestinationContent[];
  contentsBottom?: DestinationContent[];
}

export type DestinationContentViewModel = DestinationContentResponse;

export const createDefaultDestinationContent = (): DestinationContentResponse => ({
  id: '',
  createdAt: '',
  updatedAt: '',
  publishedAt: '',
  revisedAt: '',
  type: [],
  titleEn: '',
  backgroundWideMedias: [],
  backgroundTallMedias: [],
  destinationTags: [],
  summary: '',
  contents: [],
});
